<template>
    <div class="row recent-orders">
        <div class="col-sm-12 col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-12">
                    <h1 class="speq-color">SPEQ Orders</h1>
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-sm-12 col-md-2">
                    <div class="card border cursor-pointer" @click="goToOrder">
                        <div class="card-body text-center">
                            <h5>Open Orders: </h5>
                            <h5>{{ totalOrders.speq_open_count }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="card border cursor-pointer" @click="goToOrder">
                        <div class="card-body text-center">
                            <h5>Purchasable: </h5>
                            <h5>{{ totalOrders.speq_sold_count }}</h5>
                        </div>
                    </div>
                </div> -->
                <div class="col-sm-12 col-md-2">
                    <div class="card border cursor-pointer" @click="goToOrder">
                        <div class="card-body text-center">
                            <h5>Max Open Serial Numbers: </h5>
                            <h5>{{ maxOrder }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="card border cursor-pointer" @click="goToOrder">
                        <div class="card-body text-center">
                            <h5> Open Serial Numbers: </h5>
                            <h5>{{ reservedOrder }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-2">
                    <div class="card border cursor-pointer" @click="goToOrder">
                        <div class="card-body text-center">
                            <h5>Available to Order: </h5>
                            <h5>{{ remainingLines }}</h5>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-auto">
                    <div v-if="currentLocation.id != 0" class="card border">
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-auto">
                                    <label class="m-0">FFL Expiry:</label>
                                    <div>
                                        <b>{{
                                            currentLocation.ffl_expiry_date
                                        }}</b>
                                    </div>
                                </div>
                                <div class="col-md-auto">
                                    <label class="m-0">FFL #:</label>
                                    <div>
                                        <b>{{ currentLocation.ffl_number }}</b>
                                    </div>
                                </div>
                                <div class="col-md-auto">
                                    <label class="m-0">FFL EIN:</label>
                                    <div>
                                        <b>{{ currentLocation.ffl_ein }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-auto">
                                    <label class="m-0">SOT Expiry:</label>
                                    <div>
                                        <b>{{
                                            currentLocation.sot_expiry_date
                                        }}</b>
                                    </div>
                                </div>
                                <div class="col-md-auto">
                                    <label class="m-0">SOT #:</label>
                                    <div>
                                        <b>{{ currentLocation.sot_number }}</b>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-1">
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-auto">
                                            <label class="m-0">
                                                Upload SOT
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            name="sotupload"
                                            class="file-upload"
                                            @change="onChangeSot"
                                        />
                                        <button
                                            class="btn btn-action upload-btn"
                                        >
                                            Upload
                                        </button>
                                        
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="row">
                                        <div class="col-md-auto">
                                            <label class="m-0">
                                                Upload FFL
                                            </label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <input
                                            type="file"
                                            accept=".pdf"
                                            name="fflupload"
                                            class="file-upload"
                                            @change="onChangeFfl"
                                        />
                                        <button
                                            class="btn btn-action upload-btn"
                                        >
                                            Upload
                                        </button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md">
                    <div>
                        <h3>SPEQ Rules:</h3>
                        <ul>
                            <li>Limit of 25 open Serials at a time</li>
                            <li>Mark each line as sold and provide supporting documents to unlock new lines for future orders</li>
                            <li>Files must be a JPG, PNG, or PDG and must be less than 1MB in size</li>
                            <li>If a customer will not allow you to take a picture of their document(s), please process them with the 
                                <a href="/speq_valid_documents/silencerco_speq_affidavit.pdf" target="_blank">SPEQ Affidavit</a> form. You may upload this in place of a picture.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12 col-md-12">
            <br />
            <SpeqOrders
                header-title="Open Orders"
                set-status="Open"
                :page-type="'dashboard'"
                :page-type2="false"
            />
            <br />
            <SpeqOrders
                header-title="Validated Orders"
                set-status="Validated"
                :page-type="'dashboard'"
                :page-type2="false"
            />
            <br />
        </div>

        <div class="col-sm-12 col-md-2">
            
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";

import SpeqOrders from "@/components/speq/orders/SpeqOrders.vue";
import SpeqInvoices from "@/components/speq/invoices/SpeqInvoices.vue";

export default {
    props: [],
    emits: [],
    components: {
        SpeqOrders,
        SpeqInvoices,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });
        let currentLocation = computed(function () {
            return store.state.currentLocation;
        });
        let totalOrders = computed(function () {
            return store.state.totalOrders;
        });
        let maxOrder = computed(function () {
            return store.state["orderLimit"].maxOrder;
        });
        let reservedOrder = computed(function () {
            return store.state["orderLimit"].reservedOrder;
        });

        function getOrderLimit(currentLocation) {
            store.dispatch("orderLimit/getOrderLimit", { location_id: currentLocation.id});
        }

        onMounted(() => {});

        return {
            store,
            user,
            currentLocation,
            totalOrders,
            maxOrder,
            reservedOrder,
            getOrderLimit
        };
    },
    data() {
        return {
            sotFile: [],
            fflFile: [],
            sotTmp: "",
            fflTmp: "",
        };
    },
    computed: {
        remainingLines() {
            return (this.maxOrder - this.reservedOrder) > 0 ? (this.maxOrder - this.reservedOrder) : 0;
        }
    },
    mounted() {
        // this.store.dispatch("getTotalOrders", {
        //     location_id: this.currentLocation.id,
        //     is_speq: 1
        // });

        this.getOrderLimit(this.currentLocation);
        this.getLocationFiles();
    },
    methods: {
        goToOrder() {
            this.$router.push({ name: "orders", query: { filter: "open" } });
        },

        getLocationFiles() {
            axios
                .get("/api/get-location-files/" + this.currentLocation.id)
                .then((response) => {
                    let data = response.data;
                    if (data != undefined) {
                        data.forEach((item) => {
                            switch (item.type) {
                                case "SOT":
                                    this.sotTmp = item.file_name;
                                    console.log(this.sotTmp);
                                    break;
                                case "FFL":
                                    this.fflTmp = item.file_name;
                                    break;
                            }
                        });
                    }
                })
                .finally(() => {});
        },

        onChangeSot(e) {
            window.emitter.emit("changeLoaderStatus", true);
            var myFile = e.target.files[0].name;
            var upld = myFile.split(".").pop();
            if (upld == "pdf") {
                this.sotFile = e.target.files;
                const formData = new FormData();
                formData.append("attachment", this.sotFile[0]);
                formData.append("location_id", this.currentLocation.id);
                formData.append("type", "SOT");
                axios
                    .post("/api/upload-location-file", formData)
                    .then((response) => {})
                    .finally(() => {
                        window.emitter.emit("changeLoaderStatus", false);

                        window.emitter.emit("alertSuccess", {
                            message: "Successfully uploaded and will be reviewed soon.",
                        });
                    });
            } else {
                this.sotFile = [];
                $("input[name=sotupload]").val("");
            }
        },
        onChangeFfl(e) {
            var myFile = e.target.files[0].name;
            var upld = myFile.split(".").pop();
            if (upld == "pdf") {
                this.fflFile = e.target.files;
                const formData = new FormData();
                formData.append("attachment", this.fflFile[0]);
                formData.append("location_id", this.currentLocation.id);
                formData.append("type", "FFL");
                axios
                    .post("/api/upload-location-file", formData)
                    .then((response) => {})
                    .finally(() => {
                        window.emitter.emit("changeLoaderStatus", false);

                        window.emitter.emit("alertSuccess", {
                            message: "Successfully uploaded and will be reviewed soon.",
                        });
                    });
            } else {
                this.fflFile = [];
                $("input[name=sotupload]").val("");
            }
        },
    },
};
</script>
